import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { HexachipCredentialsInputDTORuntype, HexachipResponseBodyDTORuntype } from './hexachipBackendTypes';

export const hexachipEndpoints = {
    'GET /3rdparty/hexachip/credentials': endpoint({
        description: 'Returns credentials for Hexachip integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: HexachipResponseBodyDTORuntype,
    }),
    'POST /3rdparty/hexachip/credentials': endpoint({
        description: 'Uploads credentials for Hexachip API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: HexachipCredentialsInputDTORuntype,
        responseBody: HexachipResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/hexachip/credentials'],
    }),
    'PATCH /3rdparty/hexachip/credentials': endpoint({
        description: 'Updates credentials for Hexachip API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: HexachipCredentialsInputDTORuntype,
        responseBody: HexachipResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/hexachip/credentials'],
    }),
    'DELETE /3rdparty/hexachip/credentials': endpoint({
        description: 'Deletes existing credentials for Hexachip API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/hexachip/credentials'],
    }),
};
